'use es6';

import { editorConfig } from './editorConfig';
import { start } from 'ContentEditorUI/UniversalApplication';
start(editorConfig);